export enum EditorFeature {
  paragraph,
  heading,
  small,
  medium,
  fineprint,
  bold,
  italic,
  strikethrough,
  footnote,
  link,
  orderedList,
  bulletList,
  linebreak,
  nobreak,
  superscript,
  subscript,
}
